import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CompetitionImportRow} from "../../../shared/interface/competition-import-row";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Profile} from "../../../shared/interface/profile";
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {CompetitionWzService} from "../../../shared/services/competition-wz.service";

@Component({
  selector: 'app-competition-import-row-details-view',
  templateUrl: './competition-import-row-details-view.component.html',
  styleUrls: ['./competition-import-row-details-view.component.scss']
})
export class CompetitionImportRowDetailsViewComponent implements OnInit, OnDestroy {

  @Input() competitionParticipant: Observable<CompetitionImportRow>;
  @Output() modifyClicked = new EventEmitter<void>();

  participantObject?: CompetitionImportRow;
  userPermissions: ReplaySubject<UserPermissions>;
  profile: Profile;
  competitionRowId?: string = null;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private competitionWzService: CompetitionWzService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.competitionParticipant
      .pipe(takeUntil(this.destroyed$))
      .subscribe((competitionParticipant: CompetitionImportRow) => {
        this.participantObject = competitionParticipant;
        this.competitionRowId = competitionParticipant.uuid;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  generateProtocols(): void {
    this.competitionWzService.downloadProtocol(this.competitionRowId);
  }

}
